var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"value":_vm.values,"label":"Reward levels","items":_vm.items,"clearable":"","item-text":"name","item-value":"id","multiple":""},on:{"input":_vm.set}})}
var staticRenderFns = []

export { render, staticRenderFns }